<template>
  <div :class="['panel-item', {moveup}, {published:(attributes.published === 'yes')}]">
    <div class="panel-image">
        <img v-if="attributes.image" :src="getSource(attributes.image)" :alt="attributes.title" />
        <img v-else :src="getSource('template/placeholder-image.png')" alt="st-sample-image" />
    </div>
    <div class="panel-content">
        <h2 class="panel-title" v-if="attributes.title">{{attributes.title}}</h2>
        <div v-if="attributes.word">{{attributes.word}}</div>
        <a :class="['st-btn',{disable:(attributes.published !== 'yes')}]" v-if="attributes.link" :href="attributes.link">Read more</a>
    </div>
  </div>
</template>

<script>
export default {
    props: ['attributes'],
    data () {
        return {
            moveup: false
        }
    },
    mounted () {
        this.handleScroll()
        document.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
        document.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        getSource (value) {
        if (!value) return null
        return require(`images/${value}`)
        },
        handleScroll () {
           if (this.$el.getBoundingClientRect().top < (0.9 * window.innerHeight)) this.moveup = true
        }
    }
}
</script>

<style lang="scss">
.panel-item {
    opacity: 0;
    .panel-image {
        img {
        width: 100%;
        }
    }
    .panel-content {
        padding: 10px;
        // background: white;
    }
    &.moveup {
        animation: fadeInUp 0.6s ease forwards;
    }
    &:not(.published) {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
        .panel-content,
        .panel-image {
            opacity: 0.2;
        }
    }
}
</style>